document.addEventListener("DOMContentLoaded", function () {
    const $form = $("#unsubscribe_form_modal .wpcf7 form").first();
    if (!$form) return;
    var $submit = $form.find('input[type="submit"]');
    $submit.prop("disabled", true);

    function validateRequiredFields(e) {
        if (!$(e).val().trim()) {
            console.log("im empty");
            const $parent = $(e).closest(".form-group");
            showRequiredMessage($parent);
            return false;
        } else {
            const $parent = $(e).closest(".form-group");
            $parent.find(".custom-error-message.required").remove();
            return true;
        }
    }

    function validatePhoneField(e) {
        const $field = $(e);
        const $parent = $field.closest(".form-group");
        let value = $field.val().replace(/\D/g, ""); // digits only
        value = value.slice(0, 10); // max 10 digits
        $field.val(value);

        if (value.length > 0 && value.length < 10) {
            showCustomErrorMessage($parent, "phone", "Phone number must be 10 digits");
            return false;
        } else {
            $parent.find(".custom-error-message.phone").remove();
            return true;
        }
    }

    $form.on("input change blur focus", function (e) {
        checkFormValidity();
    });

    function checkFormValidity() {
        var allValid = true;

        $form.find('[aria-required="true"]').each(function (e) {
            allValid = validateRequiredFields(this);
        });

        $form.find("input.data-phone-validation").each(function () {
            if (!validatePhoneField(this)) {
                allValid = false;
            }
        });

        $submit.prop("disabled", !allValid);
    }

    function showRequiredMessage($parent, message = "This field is required") {
        if ($parent.find(".custom-error-message.required").length == 0) {
            $parent.append(createErrorMessage(message, "required"));
        }
    }

    function showCustomErrorMessage($parent, id = "", message = "This field is required") {
        if ($parent.find(".custom-error-message." + id).length == 0) {
            $parent.append(createErrorMessage(message, id));
        }
    }
    function createErrorMessage(message, id = "") {
        const $error = $("<div>", {
            class: "custom-error-message " + id,
            css: {
                color: "#aa000c",
                fontSize: ".875rem",
                position: "relative",
                alignItems: "center",
                gap: "0.5rem",
                marginTop: ".5rem",
                paddingLeft: "1.5rem",
            },
        });
        // Create the error icon
        var $icon = $("<img>", {
            src: "/wp-content/themes/goodyearforward/assets/images/icons/error.svg",
            alt: "Error",
            css: {
                width: "16px",
                height: "16px",
                position: "absolute",
                top: "0.2rem",
                left: "0",
            },
        });
        // Create the error message span
        var $message = $("<span>", {
            class: "error-text",
        }).text(message ?? "");

        // Append icon + message inside error container
        $error.append($icon).append($message);

        return $error;
    }

    document.addEventListener("wpcf7invalid", function (e) {
        if (e.target !== $form[0]) return;
        checkFormValidity();
        $submit.prop("disabled", true);
    });

    var currentDate = new Date();
    var day = String(currentDate.getDate()).padStart(2, "0");
    var month = String(currentDate.getMonth() + 1).padStart(2, "0");
    var year = currentDate.getFullYear();
    var hours = String(currentDate.getHours()).padStart(2, "0");
    var minutes = String(currentDate.getMinutes()).padStart(2, "0");

    var formattedTime = hours + ":" + minutes;
    var formattedDate = year + "-" + month + "-" + day; // yyyy-mm-dd

    // Set values in hidden fields
    $form.find('input[name="current-date"]').val(formattedDate);
    $form.find('input[name="current-time"]').val(formattedTime);
});
